import React from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Grid } from '@ff-os/shared-react/components/grid/Grid';
import { WindowHeader } from '@ff-os/shared-react/components/window/partials/WindowHeader';
import { WindowContext } from '@ff-os/shared-react/context/window/WindowContext';
import { selectPinnedVariables } from '@ff-scene-plugins/gift-redux/slices/variablesSlice';
import { GiftPdpState } from '@ff-scene-plugins/gift-redux/store';
import { GiftJson } from '@ff-scene-plugins/gift-shared/GiftJson';
import { noop } from 'lodash';
import { useOrientation } from '../../context/Orientation';
import { usePreviewSize } from '../../context/PreviewSize';
import { Variables } from '../../variables/Variables';
import { GiftWindowStepProps } from '../shared/giftWindowSteps';
import { GiftWindowFooter } from '../shared/partials/GiftWindowFooter';

const _PinnedVariablesWindow = ({
    variables,
    onClose, previous, next,
    previousButtonText, nextButtonText
}: Props) => {

    const { t } = useTranslation();
    usePreviewSize('small');
    useOrientation('screen');

    return (
        <WindowContext isOpen close={noop}>
            <WindowContext.Header>
                <WindowHeader previous={previous ?? onClose} onClose={onClose}>
                    {t('windows.pinned_variables.heading')}
                </WindowHeader>
            </WindowContext.Header>
            <WindowContext.Body>
                <Grid direction='column' gap='s'>
                    <Variables variables={variables} />
                </Grid>
            </WindowContext.Body>
            <WindowContext.Footer>
                <GiftWindowFooter
                    onClose={onClose} previous={previous} next={next}
                    previousButtonText={previousButtonText} nextButtonText={nextButtonText} />
            </WindowContext.Footer>
        </WindowContext>
    );
};

type Props = GiftWindowStepProps & {
    variables: GiftJson.Variable<any>[];
};

const mapStateToProps = (state: GiftPdpState) => ({
    variables: selectPinnedVariables(state)
});

export const PinnedVariablesWindow = connect(
    mapStateToProps
)(_PinnedVariablesWindow);